import { Box } from '@material-ui/core';
import { ClassNameMap } from '@material-ui/styles';
import { formatDateTimeReadable, Merchant } from '@nemuru-eng/js-api-client';
import React, { useEffect } from 'react';
import { generatePath } from 'react-router-dom';

import { useCustomTheme } from '../../../../../../../hooks/useCustomTheme';
import { getIconByMerchantVertical } from '../../../../../../../utils/getIconByMerchantVertical';
import { getMerchantVerticalByMerchantCategory } from '../../../../../../../utils/getMerchantVerticalByMerchantCategory';
import { DYNAMIC_PAGE_PATHS } from '../../../../../../views/DynamicPageView/config/shared/pathRoutes';
import { Font } from '../../../../Font';
import { SizedIconWithCircle } from '../../../../SizedIconWithCircle';
import { LinkToDetailButton } from './shared/LinkToDetailButton';

interface MerchantSearchResultCardProps {
  classes: ClassNameMap<'root'>;
  selected: boolean;
  searchResult: Merchant;
  toggleDialog: () => void;
  onNavigate?: boolean;
}

export const MerchantSearchResultCard = ({
  classes,
  selected,
  searchResult,
  toggleDialog,
  onNavigate,
}: MerchantSearchResultCardProps) => {
  const { palette, customBorderRadius } = useCustomTheme();

  const displayValues = {
    merchantFullName: searchResult.registrationFields.businessName,
    iconName: getIconByMerchantVertical(
      getMerchantVerticalByMerchantCategory(searchResult.registrationFields.category),
    ),
  };

  const targetPath = DYNAMIC_PAGE_PATHS.MERCHANT;
  // const richStatus = statusDefinitions[searchResult.status];
  // const type = richStatus.colorPaletteName ? richStatus.colorPaletteName : StatusTagType.DEFAULT;

  const onClick = () => {
    window.location.replace(
      generatePath(targetPath, {
        merchantId: searchResult.id,
      }),
    );
    toggleDialog();
  };

  useEffect(() => {
    if (!selected || !onNavigate) return;
    onClick();
  }, [onNavigate]);

  if (!displayValues) return <></>;

  return (
    <Box className={'appear-anim'}>
      <Box
        p={1}
        className={classes.root}
        borderRadius={customBorderRadius.paper}
        bgcolor={palette.grey[selected ? 200 : 50]}
        display={'flex'}
        flexDirection={'row'}
        justifyContent={'space-between'}
        alignItems={'center'}
        onClick={onClick}
        style={{ cursor: 'pointer' }}
      >
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          <SizedIconWithCircle
            copyToClipboard={{
              value: searchResult.id,
              textId: 'COPY_ID',
            }}
            variant={'medium'}
            iconColor={palette.secondary.main}
            backgroundColor={'transparent'}
            customBorderRadius={customBorderRadius.button}
            iconName={displayValues?.iconName}
          />
          <Box display={'flex'} flexDirection={'column'} pl={1}>
            <Font variant={'body2'} color={'title'}>
              <strong>{displayValues.merchantFullName}</strong>
            </Font>
            <Font variant={'caption'}>{formatDateTimeReadable(searchResult.createdAt)}</Font>
          </Box>
        </Box>
        <Box display={'flex'} flexDirection={'row'} alignItems={'center'}>
          {/* <StatusTag labelTextId={searchResult?.status} type={type} /> */}
          <LinkToDetailButton onClick={onClick} />
        </Box>
      </Box>
    </Box>
  );
};
